import { atom } from "jotai";

// Derived four-state onboarding status returned by GET /payout/status.
export type ConnectAccountState = 'not_started' | 'incomplete' | 'complete' | 'restricted';

// Live Stripe Connect account state (from GET /payout/status).
// The boolean triple is kept for back-compat with older backend builds; `state`
// is authoritative when present.
export interface ConnectStatus {
    details_submitted: boolean;
    charges_enabled: boolean;
    payouts_enabled: boolean;
    state?: ConnectAccountState;
    disabled_reason?: string | null;
    currently_due?: string[];
    past_due?: string[];
}

// Owed/paid summary in integer cents (from GET /payout/balance).
export interface PayoutBalance {
    owed_cents: number;
    paid_cents: number;
    currency: string;
}

export type PayoutLedgerEntryType = 'accrued' | 'paid' | 'adjustment';

// One ledger row (from GET /payout/ledger).
export interface PayoutLedgerEntry {
    id: number;
    created_at: string;
    brand_id: number;
    order_id: number | null;
    line_item_id: number | null;
    design_id: number | null;
    entry_type: PayoutLedgerEntryType;
    amount_cents: number;
    currency: string;
    stripe_transfer_id: string | null;
    note: string | null;
}

// One page of ledger rows plus the total matching row count.
export interface PayoutLedgerPage {
    rows: PayoutLedgerEntry[];
    total: number;
    limit: number;
    offset: number;
}

// Pagination + optional ISO date range passed to getLedger.
export interface PayoutLedgerQuery {
    limit: number;
    offset: number;
    from?: string;
    to?: string;
}

export const payoutStatusAtom = atom<ConnectStatus | null>(null);
export const payoutBalanceAtom = atom<PayoutBalance | null>(null);
export const payoutLedgerAtom = atom<PayoutLedgerPage | null>(null);
export const payoutLoadingAtom = atom<boolean>(false);
